import user_list from "./user_list_zh";
import user_detail from "./user_detail_zh";
import memberCard from "./memberCard_zh";
const userModel = {
    user_list,
    user_detail,
    memberCard
};

export default userModel;
